import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Inject,
  TemplateRef,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface IConfirmationDialogData {
  title: string;
  content: string;
  yesButtonLabel: string;
  noButtonLabel: string;
  usersChoice: boolean;
  showYesButton: boolean;
  showNoButton: boolean;
  yesButtonTemplate?: TemplateRef<any>;
}

@Component({
  templateUrl: './confirmation-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: IConfirmationDialogData,
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
  ) {}

  ngOnInit(): void {
    //if (!this.data) {
    this.data = {
      ...{
        title: 'Confirmation Title',
        content: 'Confirmation Text',
        yesButtonLabel: 'Yes',
        noButtonLabel: 'No',
        usersChoice: false,
        showYesButton: true,
        showNoButton: true,
      },
      ...this.data,
    };
    //}
  }

  onYesButtonClick(): void {
    this.data.usersChoice = true;
    this.closeSelf();
  }

  onNoButtonClick(): void {
    this.data.usersChoice = false;
    this.closeSelf();
  }

  private closeSelf(): void {
    this.dialogRef.close(this.data.usersChoice);
  }
}
